// extracted by mini-css-extract-plugin
export default {"workflow":"add_workflow__3g8yo","title":"add_title__SUJpC","form":"add_form__hcjNb","footer":"add_footer__0qacX"};